import React from 'react'
import cn from 'classnames'

import styles from './styles.less'

export default function SidebarAlert({ className }) {
  return <span className={cn(styles.SidebarItem_alert, className)}>&nbsp;</span>
}
